import React, { useState, useEffect } from 'react'

import { Switch } from '@headlessui/react'

interface ToggleButtonProps {
	enableText: string
	disableText: string
	isEnabled?: boolean
	onChange: (checked: boolean) => void
	id?: string
}

const styles = {
	switchGroup: 'flex items-center',
	span: 'font-medium text-sm',
	spanEnable: 'text-primary',
	spanDisable: 'text-gray',
	switch:
		'relative inline-flex flex-shrink-0 h-6 w-11 border-2 rounded-full cursor-pointer transition-colors ease-in-out duration-200 mx-4',
	switchEnable: 'bg-primary border-primary',
	switchDisable: 'bg-gray-200 border-gray-200',
	switchSpan:
		'pointer-events-none inline-block h-5 w-5 rounded-full bg-white transform ring-0 transition ease-in-out duration-200',
	switchSpanEnable: 'translate-x-5',
	switchSpanDisable: 'translate-x-0',
}

export default function ToggleButton({
	enableText,
	disableText,
	isEnabled = false,
	onChange,
	id,
}: ToggleButtonProps) {
	const [enabled, setEnabled] = useState(isEnabled)

	useEffect(() => {
		onChange(enabled)
	}, [enabled, onChange])

	return (
		<Switch.Group as='div' className={styles.switchGroup} id={id}>
			<span
				className={`${styles.span} ${
					enabled ? styles.spanDisable : styles.spanEnable
				}`}
			>
				{disableText}
			</span>

			<Switch
				checked={enabled}
				onChange={setEnabled}
				className={`${styles.switch} ${
					enabled ? styles.switchEnable : styles.switchDisable
				}`}
			>
				<span
					aria-hidden='true'
					className={`${styles.switchSpan} ${
						enabled ? styles.switchSpanEnable : styles.switchSpanDisable
					}`}
				/>
			</Switch>

			<span
				className={`${styles.span} ${
					enabled ? styles.spanEnable : styles.spanDisable
				}`}
			>
				{enableText}
			</span>
		</Switch.Group>
	)
}
